<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="T1" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6t8fxlmylj31hc0rstdi.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6t8fy0v06j31hc0rsn08.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6t8fyf6xhj31hc0rsq54.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6t8fyw3v5j31hc0rsdix.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g6t8fzijq1j31hc0rsmzs.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g6t8g033icj31hc0rstaw.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g6t8g0l17rj31hc0rsak2.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6t8g14pqxj31hc0rswh9.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g6t8g1wfuej31hc0rs409.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6t8g2kjdcj31hc0rsdin.jpg"/>
        <!-- 手机端 -->
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6u615lvw9j30ku0rst9h.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6u6162gspj30ku0rswfp.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6u616k79oj30ku0rs0tz.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6u6171il0j30ku0rstc7.jpg"/>
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g6u617ifj9j30ku0rsabn.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g6u61859lxj30ku0rsgn6.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g6u618lqzpj30ku0rsjs7.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g6u6191ynsj30ku0rswfm.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
            swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                pagination: '.swiper-pagination',
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                paginationClickable: true,
                loop: true,
                // mousewheelControl : true,
                observeParents: true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
            },
            seletedColor: 0,
            earphones1: ["http://wx1.sinaimg.cn/large/0067mezugy1g5c8ii1tgtj30c60e6q36.jpg", "http://wx3.sinaimg.cn/large/0067mezugy1g5c8iik6krj30ct0e5aab.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g5c8iizicoj30e60c8mxa.jpg"],
            earphones2: ["http://wx4.sinaimg.cn/large/0067mezugy1g5c8ijh02oj30bc0dndfz.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g5c8ik5ep9j30cs0e4wen.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g5c8ikm8k4j30eh0dfjrf.jpg"],
            iconList: [{
                icon: require("../../../assets/img/n/icon1.png"),
                title: "美国高通芯片"
            },{
                icon: require("../../../assets/img/n/icon2.png"),
                title: "蓝牙5.0标准"
            },{
                icon: require("../../../assets/img/n/icon3.png"),
                title: "CVC8.0降噪技术"
            },{
                icon: require("../../../assets/img/n/icon4.png"),
                title: "内置记忆钢丝颈挂"
            },{
                icon: require("../../../assets/img/n/icon5.png"),
                title: "双声道音频并行处理"
            },{
                icon: require("../../../assets/img/n/icon6.png"),
                title: "7小时无忧续航"
            },{
                icon: require("../../../assets/img/n/icon7.png"),
                title: "人体工学设计"
            },{
                icon: require("../../../assets/img/n/icon8.png"),
                title: "自动记忆配对蓝牙"
            },{
                icon: require("../../../assets/img/n/icon9.png"),
                title: "运动防汗"
            },{
                icon: require("../../../assets/img/n/icon10.png"),
                title: "轻若无物"
            }]
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        }
    }
}
</script>
<style scoped>

.pro_animation .pro_colors i:nth-child(1){
	background-image: url(../../../assets/img/n/pa_1.png);
}

.pro_animation .pro_colors i:nth-child(2){
	background-image: url(../../../assets/img/n/pa_2.png);
	margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/T/t1.vue